module.exports = __webpack_public_path__ + "media/img/illustrations/plus-0ec0b65f9e9b099f380b26689e8373db.svg";